// import history from '../lib/history.js';

export const isMobil = () => {
  const flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return flag;
}

export const setCookie = (name: any, value: any, expires?: any, path: any = '/', domain?: any, secure?: any) => {
  let str = name + '=' + encodeURIComponent(value)
  if (expires > 0) {
    const date = new Date()
    date.setTime(date.getTime() + expires * 3600 * 1000)
    str += ';expires=' + date.toUTCString()
  }
  if (path) {
    str += ';path=' + path
  }
  if (domain) {
    str += ';domain=' + domain
  }
  if (secure) {
    str += ';secure=' + secure
  }
  document.cookie = str
}

export const getCookie = (name: any) => {
  const start = document.cookie.indexOf(name + '=')
  if ((!start) && (name !== document.cookie.substring(0, name.length))) {
    return ''
  }
  if (start === -1) {
    return ''
  }
  const len = start + name.length + 1
  let end = document.cookie.indexOf(';', len)
  if (end === -1) {
    end = document.cookie.length
  }
  return decodeURIComponent(document.cookie.substring(len, end))
}

export const getLocalStorage = (name: any) => {
  if (!window.localStorage) {
    alert('浏览器不支持localstorage');
    return false;
  } else {
    const storage = window.localStorage;
    return storage.getItem(name);
  }
}

export const setLocalStorage = (name: any, value: any) => {
  if (!window.localStorage) {
    alert('浏览器不支持localstorage');
  } else {
    const storage = window.localStorage;
    storage.setItem(name, value);
  }
}

export const deleteLocalStorage = (name: any) => {
  if (!window.localStorage) {
    alert('浏览器不支持localstorage');
  } else {
    const storage = window.localStorage;
    storage.removeItem(name);
  }
}

// 判断是否为微信
export const isWechat = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.indexOf('micromessenger') > -1) {
    return true
  }
  return false
}

// 时间戳转换
export const formatData = (time: any, form: any = 'Y-M-D') => {
  if (time === '') {
    return '';
  }
  const timeStamp = new Date(Date.parse(time));
  const year = timeStamp.getFullYear(); // 年
  const month: any = timeStamp.getMonth() + 1 < 10 ? `0${ timeStamp.getMonth() + 1 }` : timeStamp.getMonth() + 1; // 月
  const date: any = timeStamp.getDate() < 10 ? `0${ timeStamp.getDate() }` : timeStamp.getDate(); // 日
  const hour: any = timeStamp.getHours() < 10 ? `0${ timeStamp.getHours() }` : timeStamp.getHours(); // 时
  const minute: any = timeStamp.getMinutes() < 10 ? `0${ timeStamp.getMinutes() }` : timeStamp.getMinutes(); // 分
  const second: any = timeStamp.getSeconds() < 10 ? `0${ timeStamp.getSeconds() }` : timeStamp.getSeconds(); // 秒
  if (form.indexOf('Y') >= 0) {
    form = form.replace('Y', year);
  }
  if (form.indexOf('M') >= 0) {
    form = form.replace('M', month);
  }
  if (form.indexOf('D') >= 0) {
    form = form.replace('D', date);
  }
  if (form.indexOf('hh') >= 0) {
    form = form.replace('hh', hour);
  }
  if (form.indexOf('mm') >= 0) {
    form = form.replace('mm', minute);
  }
  if (form.indexOf('ss') >= 0) {
    form = form.replace('ss', second);
  }
  return form;
}

// 校验手机
export const verifyPhone = (phone: any) => {
  const isPhone = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
  return isPhone.test(phone);
}

// 校验纯数字
export const verifyNumber = (number: any) => {
  const isNumber = /^\d+(\.\d+)?$/; // 数字
  return isNumber.test(number);
}

// 校验邮箱
export const verifyEmail = (email: any) => {
  const isEmail = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/; // 数字
  return isEmail.test(email);
}

// 校验银行卡
export const verifyBankCardNumber = (bankCardNumber: any) => {
  const isBankCardNumber = /^([1-9]{1})(\d{15}|\d{18})$/; // 数字
  return isBankCardNumber.test(bankCardNumber);
}

// 校验身份证
export const verifyIdCard = (code: any) => {
  const city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江 ',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北 ',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏 ',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外 '
  };
  let tip = '';
  let pass = true;
  if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
    tip = '身份证号格式错误';
    pass = false;
  } else if (!city[code.substr(0, 2)]) {
    tip = '地址编码错误';
    pass = false;
  } else {
    //18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('');
      //∑(ai×Wi)(mod 11)
      //加权因子
      const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      //校验位
      const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
      let sum = 0;
      let ai = 0;
      let wi = 0;
      for (let i = 0; i < 17; i++) {
        ai = code[i];
        wi = factor[i];
        sum += ai * wi;
      }
      const last = parity[sum % 11];
      if (parity[sum % 11] != code[17]) {
        tip = '被保人证件校验位错误';
        pass = false;
      }
    }
  }
  return pass;
}

// 根据出生日期算出年龄
export const getAge = (birthday: any) => {
  let age = 0;
  const birthdayArr = birthday.split('-');
  const birthYear = Number(birthdayArr[0]);
  const birthMonth = Number(birthdayArr[1]);
  const birthDay = Number(birthdayArr[2]);

  const d = new Date();
  const nowYear = d.getFullYear();
  const nowMonth = d.getMonth() + 1;
  const nowDay = d.getDate();

  if (nowYear !== birthYear) {
    age = nowYear - birthYear ; // 年之差
    if (age > 0) {
      if (nowMonth === birthMonth) {
        const dayDiff = nowDay - birthDay;// 日之差
        if (dayDiff < 0) {
          age = age - 1;
        }
      }
      else {
        const monthDiff = nowMonth - birthMonth;// 月之差
        if (monthDiff < 0) {
          age = age - 1;
        }
      }
    } else {
      age = -1;// 返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return age;// 返回周岁年龄
}

// 根据身份证获取生日
export const getBirthdayFromIdCard = (idCard) => {
  let birthday = '';
  if (idCard != null && idCard != '') {
    if (idCard.length == 15) {
      birthday = '19' + idCard.substr(6, 6);
    } else if (idCard.length == 18) {
      birthday = idCard.substr(6, 8);
    }
    birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-');
  }
  return birthday;
}

// 根据身份证获取性别
export const computeSexByIdCard = (idCard) => {
  //获取性别
  if (parseInt(idCard.substr(16, 1)) % 2 == 1) {
    //男
    return 'M';
  } else {
    return 'F';
  }
}

// 转化性别
export const formatSex = (sex: any) => {
  switch(sex) {
    case 'M': return '男';
    case 'F': return '女';
    default: return '';
  }
}

// 转化证件
export const formatCertType = (certType: any) => {
  switch(certType) {
    case 'id_card': return '身份证';
    case 'birth_cert': return '出生证';
    default: return '';
  }
}

// 转化数组大写
export const formatNumber = (number: any) => {
  switch(number) {
    case 1: return '一';
    case 2: return '二';
    case 3: return '三';
    case 4: return '四';
    case 5: return '五';
    case 6: return '六';
    case 7: return '七';
    case 8: return '八';
    case 9: return '九';
    case 10: return '十';
    default: return '';
  }
}

// 转化关系
export const formatRelationship = (relationship: any) => {
  switch(relationship) {
    case 'parents': return '父母';
    case 'couple': return '配偶';
    case 'children': return '子女';
    default: return '';
  }
}

// 转化单位
export const formatUnit = (number: any, unit: any) => {
  switch(unit) {
    case 'year': return `${number}年`;
    case 'life': return '保终生';
    case 'age': return `保至${number}岁`;
    default: return '';
  }
}

// 转化交费单位
export const formatPayUnit = (unit: any) => {
  switch(unit) {
    case 'year': return '年交';
    default: return '';
  }
}
